import React, { ElementType, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLElement> {
  children: string;
  renderWith?: ElementType;
}

const RenderDangerously: React.FC<Props> = ({
  renderWith: Tag = 'div',
  children,
  ...rest
}) => (
  <Tag
    dangerouslySetInnerHTML={{
      __html: children,
    }}
    {...rest}
  />
);

export { RenderDangerously };
